import hampi from '../assets/home/ResizeHmapiLink.jpg';
import dandeli from '../assets/home/trvto_dandeli.jpg';
import munnar from '../assets/home/trvto_munnar.jpg';
import netravathi from '../assets/home/trvto_netravathi.jpg';
import jhariFalls from '../assets/home/trvto_Jhari_Falls.jpg';
import kuduremukha from '../assets/home/trvto_kuduremukha.jpg';
import wayanad from '../assets/home/trvto_wayanad.jpg';
import gokarna from '../assets/home/trvto_gokarna.jpg';
import nandhi from '../assets/home/trvto_nandhi_hills.jpg';
import goa from '../assets/home/trvto_goa.jpg';
import himalaya from '../assets/home/trvto_leh.jpg';
import manali from '../assets/home/trvto_manali.jpg';
import udupi from '../assets/home/trvto_udupi.jpg';
import kashmir from '../assets/home/trvto_kashmir.jpg';
import kodachadri from '../assets/home/trvto_chickmangaluru.jpg';
import spiti from '../assets/home/trvto_spiti.jpg';
import rajasthan from '../assets/home/trvto_rajasthan.jpg';
import spitiWinter from '../assets/home/trvto_winter_spiti.jpg';
import mysuru from '../assets/home/trvto_mysuru.jpg';
import tamilnadu from '../assets/home/trvto_tamilnadu.jpg';
import pondicherry from '../assets/home/trvto_goa_beach.jpg';
import kerala from '../assets/home/trvto_kerala.jpg';
import jog from '../assets/home/trvto_jog.jpg';
import ooty from '../assets/home/trvto_ooty.jpg';

export const adventureData = [
    {
        id: 1,
        image: hampi,
        title: 'Hampi'
    },
    {
        id: 2,
        image: jhariFalls,
        title: 'Chikmagaluru'
    },
    {
        id: 3,
        image: netravathi,
        title: 'Netravati Trek'
    },
    {
        id: 4,
        image: kuduremukha,
        title: 'Kuduremukha Trek'
    },
    {
        id: 5,
        image: munnar,
        title: 'Munnar'
    },
    {
        id: 6,
        image: wayanad,
        title: 'Wayanad'
    },
    {
        id: 7,
        image: gokarna,
        title: 'Gokarna'
    },
    {
        id: 8,
        image: nandhi,
        title: 'Nandi Hills'
    },
    {
        id: 9,
        image: goa,
        title: 'Goa'
    },
    {
        id: 10,
        image: himalaya,
        title: 'Himalaya'
    },
    {
        id: 11,
        image: dandeli,
        title: 'Dandeli'
    },
    {
        id: 12,
        image: kashmir,
        title: 'Kashmir'
    },
    {
        id: 13,
        image: udupi,
        title: 'Udupi'
    },
    {
        id: 14,
        image: manali,
        title: 'Manali'
    },

    {
        id: 15,
        image: kodachadri,
        title: 'Kodachadri'
    },
    {
        id: 16,
        image: ooty,
        title: 'Ooty'
    },
    {
        id: 17,
        image: jog,
        title: 'Jog Falls'
    },
    {
        id: 18,
        image: mysuru,
        title: 'Mysuru'
    },
    {
        id: 19,
        image: pondicherry,
        title: 'Pondicherry'
    },
    {
        id: 20,
        image: kerala,
        title: 'Alappuzha'
    },
    {
        id: 21,
        image: spiti,
        title: 'Spiti'
    },
    {
        id: 22,
        image: tamilnadu,
        title: 'tamilnadu'
    },
    {
        id: 23,
        image: rajasthan,
        title: 'Rajasthan'
    },
    {
        id: 24,
        image: spitiWinter,
        title: 'Spiti Winter'
    }
];
